"use clent";

import logo2 from "../../asset-source/logo-wjet.svg";
import { useState, useEffect } from "react";
import logoW from "../../asset-source/logo-w.png";
import "./styles.css";
import ContactUsModal from "../modal/contact-us";
import { useNavigate } from "react-router-dom";

export const Header = ({ onLight = false, flink, isTitlePage }) => {
  const [scrolled, setScrolled] = useState(0);
  const [headerStyles, setHeaderStyles] = useState("header");
  const [isMenuActive, setIsMenuActive] = useState(false);

  const navigate = useNavigate();

  const headerDOM = document.getElementById("header");

  const handleScroll = (element) => {
    setScrolled(window.scrollY);
  };

  useEffect(() => {
    if (headerDOM) {
      window?.addEventListener("scroll", handleScroll);
    }

    if (onLight && scrolled < 10) {
      setHeaderStyles("header header--alternative header--dark");
    } else {
      setHeaderStyles("header header--alternative");
    }

    return () => {
      window?.removeEventListener("scroll", handleScroll);
    };
  }, [headerDOM, onLight, scrolled]);

  return (
    <header
      id="header"
      className={headerStyles}
      style={{ background: scrolled < 10 ? "transparent" : "white" }}
    >
      <div className="container">
        <div className="header__container">
          <div>
            <a
              href="/"
              className="logo"
            >
              {onLight && scrolled < 10 ? (
                <img
                  src={logo2}
                  alt=""
                />
              ) : (
                <img
                  src={logoW}
                  alt=""
                />
              )}
            </a>
            <nav className="nav">
              <a href="/cases">Кейсы</a>
              <a href="/services">Услуги</a>
              <a href="/about">О нас</a>
              <a href="#contacts">Контакты</a>
            </nav>
          </div>

          <div className="right">
            <a
              href="https://t.me/wjet_io"
              target="_blank"
              className={isTitlePage ? "tg titleTg" : "tg"}
              rel="noreferrer"
            >
              <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_0_3)">
                    <path
                      d="M4 20C4 11.1634 11.1634 4 20 4C28.8366 4 36 11.1634 36 20C36 28.8366 28.8366 36 20 36C11.1634 36 4 28.8366 4 20Z"
                      fill="white"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20ZM20.7167 14.7649C18.7714 15.574 14.8836 17.2487 9.05316 19.7889C8.10639 20.1654 7.61043 20.5337 7.56528 20.8938C7.48898 21.5025 8.25119 21.7422 9.28912 22.0685C9.4303 22.1129 9.57659 22.1589 9.72656 22.2077C10.7477 22.5396 12.1214 22.928 12.8355 22.9434C13.4832 22.9574 14.2062 22.6903 15.0044 22.1422C20.4519 18.465 23.264 16.6064 23.4405 16.5663C23.5651 16.538 23.7377 16.5025 23.8546 16.6064C23.9716 16.7104 23.9601 16.9072 23.9477 16.96C23.8722 17.2819 20.8802 20.0635 19.3319 21.503C18.8492 21.9517 18.5068 22.27 18.4368 22.3427C18.28 22.5056 18.1202 22.6596 17.9666 22.8077C17.0179 23.7222 16.3065 24.408 18.006 25.528C18.8227 26.0662 19.4763 26.5112 20.1283 26.9552C20.8403 27.4401 21.5505 27.9238 22.4694 28.5261C22.7035 28.6796 22.927 28.839 23.1448 28.9942C23.9735 29.585 24.7179 30.1157 25.6376 30.0311C26.1721 29.9819 26.7241 29.4794 27.0045 27.9806C27.667 24.4386 28.9694 16.7641 29.2704 13.6016C29.2967 13.3246 29.2636 12.97 29.2369 12.8143C29.2103 12.6586 29.1546 12.4368 28.9523 12.2727C28.7127 12.0782 28.3427 12.0372 28.1773 12.0401C27.425 12.0534 26.2709 12.4547 20.7167 14.7649Z"
                      fill="#242323"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_0_3">
                      <rect
                        width="40"
                        height="40"
                        fill="white"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </svg>
            </a>

            <button
              className={isTitlePage ? "btn titleBtn" : "btn"}
              onClick={() => {
                navigate(`?modal`);
              }}
            >
              Обсудить проект
            </button>
          </div>

          <div className="header--mobile">
            <a
              href="https://t.me/wjet_io"
              target="_blank"
              className={isTitlePage ? "tg titleTg" : "tg"}
              rel="noreferrer"
            >
              <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_2612_8471)">
                  <path
                    d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
                    fill="white"
                    className="plane"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20ZM20.7167 14.7649C18.7714 15.574 14.8836 17.2487 9.05316 19.7889C8.10639 20.1654 7.61043 20.5337 7.56528 20.8938C7.48898 21.5025 8.25119 21.7422 9.28912 22.0685C9.4303 22.1129 9.57659 22.1589 9.72656 22.2077C10.7477 22.5396 12.1214 22.928 12.8355 22.9434C13.4832 22.9574 14.2062 22.6903 15.0044 22.1422C20.4519 18.465 23.264 16.6064 23.4405 16.5663C23.5651 16.538 23.7377 16.5025 23.8546 16.6064C23.9716 16.7104 23.9601 16.9072 23.9477 16.96C23.8722 17.2819 20.8802 20.0635 19.3319 21.503C18.8492 21.9517 18.5068 22.27 18.4368 22.3427C18.28 22.5056 18.1202 22.6596 17.9666 22.8077C17.0179 23.7222 16.3065 24.408 18.006 25.528C18.8227 26.0662 19.4763 26.5112 20.1283 26.9552C20.8403 27.4401 21.5505 27.9238 22.4694 28.5261C22.7035 28.6796 22.927 28.839 23.1448 28.9942C23.9735 29.585 24.7179 30.1157 25.6376 30.0311C26.1721 29.9819 26.7241 29.4794 27.0045 27.9806C27.667 24.4386 28.9694 16.7641 29.2704 13.6016C29.2967 13.3246 29.2636 12.97 29.2369 12.8143C29.2103 12.6586 29.1546 12.4368 28.9523 12.2727C28.7127 12.0782 28.3427 12.0372 28.1773 12.0401C27.425 12.0534 26.2709 12.4547 20.7167 14.7649Z"
                    fill="#242323"
                    className="bg"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_2612_8471">
                    <path
                      d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
                      fill="white"
                    />
                  </clipPath>
                </defs>
              </svg>
            </a>

            <div
              className={isMenuActive ? "nav--btn open" : "nav--btn"}
              onClick={() => {
                setIsMenuActive(!isMenuActive);
              }}
            >
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </div>

      {isMenuActive ? (
        <div className="nav__mobile wrapper">
          <div className="nav__mobile content">
            <div className="logo">
              {/* <img src={logo} alt="" /> */}
              <img
                src={logo2}
                alt=""
              />
            </div>

            <nav className="nav">
              <a
                href="/cases"
                onClick={() => {
                  setIsMenuActive(!isMenuActive);
                }}
              >
                Кейсы
              </a>
              <a
                href="services"
                onClick={() => {
                  setIsMenuActive(!isMenuActive);
                }}
              >
                Услуги
              </a>
              <a
                href="/about"
                onClick={() => {
                  setIsMenuActive(!isMenuActive);
                }}
              >
                О нас
              </a>

              <a
                href="#contacts"
                onClick={() => {
                  setIsMenuActive(!isMenuActive);
                }}
              >
                Контакты
              </a>
            </nav>
            <button
              className="btn"
              onClick={() => {
                setIsMenuActive(false);
                navigate(`?modal`);
              }}
            >
              Обсудить проект
            </button>
          </div>
        </div>
      ) : (
        <></>
      )}

      <ContactUsModal />
    </header>
  );
};
